import { createContext, useState } from 'react';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [Token, setToken] = useState(null);
  const [Authorised, setAuthorised] = useState(false);
  const [UserType, setUserType] = useState('');

  return (
    <AuthContext.Provider value={{ Token, setToken, Authorised, setAuthorised, UserType, setUserType }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
